/**
 * Where the CLI installs from: the gateway the browser uses, which serves /cli on SaaS and on a
 * self-hosted deployment alike, else the tenant's own moderne.io host.
 */
export const cliBaseUrl = (
  apiGatewayUrl: string | undefined,
  tenantName: string
): string => apiGatewayUrl ?? `https://${tenantName}.moderne.io`;

/** What a workstation runs to use a new token: the CLI pointed at this deployment, then logged in with it. */
export const workstationCommands = (
  origin: string,
  apiGatewayUrl: string | undefined,
  token: string
): string =>
  `mod config moderne edit ${origin}${apiGatewayUrl ? ` --api ${apiGatewayUrl}` : ''}\n` +
  `mod config moderne login --with-token ${token}`;
